import { render, staticRenderFns } from "./RelationshipToChild.vue?vue&type=template&id=055e3fb7"
import script from "./RelationshipToChild.vue?vue&type=script&lang=ts"
export * from "./RelationshipToChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports